module.exports = __webpack_public_path__ + "br.182f9e334da7c92b4fa9.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/br.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/br.svg
// module chunks = styles